export default "__VITE_ASSET__DPdG0CkI__"